export function formatGooglePlaceDetails({ placeDetails }) {
  const { addressComponents, viewport } = placeDetails;
  const country = addressComponents.find((component) =>
    component.types.includes("country")
  );
  const region = addressComponents.find((component) =>
    component.types.includes("administrative_area_level_1")
  );
  const colloquialArea = addressComponents.find((component) =>
    component.types.includes("colloquial_area")
  );
  const subRegion = addressComponents.find((component) =>
    component.types.includes("administrative_area_level_2")
  );
  const locality = addressComponents.find(
    (component) =>
      component.types.includes("locality") ||
      component.types.includes("administrative_area_level_3")
  );
  const district = addressComponents.find((component) =>
    component.types.includes("sublocality_level_1")
  );
  const neighborhood = addressComponents.find(
    (component) =>
      component.types.includes("sublocality_level_2") ||
      component.types.includes("neighborhood")
  );
  const place = addressComponents[0];

  const placeData = {
    divisions: {
      country: {
        name: country?.longText,
        code: country?.shortText,
      },
      region: {
        name: region?.longText ?? null,
        code: region?.shortText ?? null,
      },
      colloquial_area: {
        name: colloquialArea?.longText ?? null,
        code: colloquialArea?.shortText ?? null,
      },
      sub_region: {
        name: subRegion?.longText ?? null,
        code: subRegion?.shortText ?? null,
      },
      locality: {
        name: locality?.longText ?? null,
        code: locality?.shortText ?? null,
      },
      district: {
        name: district?.longText ?? null,
        code: district?.shortText ?? null,
      },
      neighborhood: {
        name: neighborhood?.longText ?? null,
        code: neighborhood?.shortText ?? null,
      },
      place: {
        name: place?.longText ?? null,
        code: place?.shortText ?? null,
      },
    },
    feature_types: placeDetails?.types,
    formatted_place: placeDetails?.formattedAddress,
    geometry: {
      bounding_box: {
        northEast: viewport?.high,
        southWest: viewport?.low,
      },
      coordinates: placeDetails?.location,
    },
    google_maps_url: placeDetails?.googleMapsUri,
    id: placeDetails?.name,
    name: placeDetails?.displayName?.text ?? placeDetails?.displayName,
    short_formatted_place: placeDetails?.shortFormattedAddress,
    utc_offset: placeDetails?.utcOffsetMinutes,
    originalDisplayName: placeDetails?.originalDisplayName,
    originalFormattedAddress: placeDetails?.originalFormattedAddress,
    originalShortFormattedAddress: placeDetails?.originalShortFormattedAddress,
  };

  return placeData;
}
